import React from 'react';
import { connect } from 'react-redux';
import R from 'ramda';
import PropTypes from 'prop-types';
import { HeroFullOverlay, HeroFullBlock } from '@cotyorg/ccx-organism-hero';
import Heading from '@cotyorg/ccx-atoms/Heading';
import Paragraph from '@cotyorg/ccx-atoms/Paragraph';
import Link from '@cotyorg/ccx-atoms/Link';
import StandardLayout from '../../templates/StandardLayout';
import SectionHeader from '../../atoms/SectionHeader';
import { isLargeBreakpoint } from '../../utils';

const AboutComponent = ({
  currentBreakpoint,
  noOfHeroSection1Heroes,
  sectionHeadings,
  ctas,
}) => (
  <StandardLayout>
    <div className="about-page">
      <div className="grid-container">
        <div className="grid-x grid-margin-x">
          <div className="cell">
            <div className="hero-absolute-image">
              <HeroFullOverlay heroStoreDataKey="heroSection1MainHero" />
            </div>
          </div>
          <div className="cell xsmall-14 xsmall-offset-1">
            {[...Array(noOfHeroSection1Heroes)].map((item, index) => {
              const isContentFirst =
                index % 2 !== 0 && isLargeBreakpoint({ currentBreakpoint });

              return (
                <HeroFullBlock
                  heroStoreDataKey={`heroSection1Hero${index + 1}`}
                  isContentFirst={isContentFirst}
                  isUnderlined={false}
                />
              );
            })}
          </div>

          <div className="cell">
            <div className="hero-absolute-image">
              <HeroFullOverlay heroStoreDataKey="heroSection2Hero" />
            </div>
          </div>
          <div className="cell xsmall-14 xsmall-offset-1 large-9">
            <SectionHeader textAlign="left">
              <Heading extraClass="section__title aboutPage__heading" level={2}>
                {R.path(['heroSection2', 'heading'])(sectionHeadings)}
              </Heading>
              <Paragraph>
                {R.pathOr(
                  '',
                  ['heroSection2', 'introduction'],
                  sectionHeadings
                )}
              </Paragraph>
            </SectionHeader>
          </div>

          <div className="cell">
            <div className="hero-absolute-image">
              <HeroFullOverlay heroStoreDataKey="heroSection3Hero" />
            </div>
          </div>
          <div className="cell xsmall-14 xsmall-offset-1 large-9">
            <SectionHeader textAlign="left">
              <Heading extraClass="section__title aboutPage__heading" level={2}>
                {R.path(['heroSection3', 'heading'])(sectionHeadings)}
              </Heading>
              <Paragraph>
                {R.pathOr(
                  '',
                  ['heroSection3', 'introduction'],
                  sectionHeadings
                )}
              </Paragraph>
              <Paragraph>
                <Link
                  extraClass="uppercase"
                  link={R.path(['heroSection3', 'url'], ctas)}
                >
                  {R.path(['heroSection3', 'text'], ctas)}
                </Link>
              </Paragraph>
            </SectionHeader>
          </div>
        </div>
      </div>
    </div>
  </StandardLayout>
);

AboutComponent.propTypes = {
  currentBreakpoint: PropTypes.string,
  noOfHeroSection1Heroes: PropTypes.number,
  sectionHeadings: PropTypes.objectOf(PropTypes.object),
  ctas: PropTypes.objectOf(PropTypes.object),
};

export default connect(({ content, breakpoints }) => ({
  currentBreakpoint: R.prop('current', breakpoints),
  noOfHeroSection1Heroes: R.path(['custom', 'noOfHeroSection1Heroes'], content),
  sectionHeadings: R.prop('sectionHeadings', content),
  ctas: R.prop('ctas', content),
}))(AboutComponent);
